import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useHttp } from "../../../hooks/useHttp";

export const useGetTeam = ({ manuallyCall = false, dependencies = [] }) => {
  const [team, setTeam] = useState({});
  const { sport, organizationId, entityId } = useParams();

  const { loading, error, request, cleanError } = useHttp();

  const fetchTeam = useCallback(async () => {
    try {
      const res = await request({
        url: `/v1/${sport}/o/${organizationId}/entities/${entityId}`,
      });
      const data = res?.data?.[0] || {};
      setTeam(data);
    } catch (e) {
      console.error(e);
    }
  }, [sport, organizationId, entityId, request]);

  useEffect(() => {
    if (!manuallyCall) {
      fetchTeam();
    }
  }, [...dependencies, manuallyCall, fetchTeam]);

  return { fetchTeam, loading, error, cleanError, team };
};
